import { FormControl, InputLabel, MenuItem, Select } from '@mui/material';
import React from 'react';
import {
 Control,
 Controller,
 FieldErrors,
 UseFormSetValue,
} from 'react-hook-form';
import { useTranslation } from 'react-i18next';

import SelectApi from '../../common/SelectApi';
import { WidgetProgressProps } from '../Dashboard.types';

interface DriversProgressFiltersProps {
 control: Control<WidgetProgressProps>;
 setValue: UseFormSetValue<WidgetProgressProps>;
 errors: FieldErrors<WidgetProgressProps>;
}

const DriversProgressFilters: React.FC<DriversProgressFiltersProps> = ({
 control,
 setValue,
 errors,
}) => {
 const { t } = useTranslation();
 const customerFilter = JSON.stringify({ fields: 'Id,Name' });
 const driverFilter = JSON.stringify({ fields: 'Id,FullName' });

 return (
  <>
   <SelectApi<WidgetProgressProps>
    name="sender"
    url="/api/Customers/v2/"
    filter={customerFilter}
    label={t('dashboard.filters.sender')}
    isEditable
    operator="contains"
    control={control}
    setValue={setValue}
   />
   <SelectApi<WidgetProgressProps>
    name="receiver"
    url="/api/Customers/v2/"
    filter={customerFilter}
    label={t('dashboard.filters.receiver')}
    isEditable
    operator="contains"
    control={control}
    setValue={setValue}
   />
   <SelectApi<WidgetProgressProps>
    name="driver"
    url="/api/Drivers/v2/"
    filter={driverFilter}
    label={t('dashboard.filters.driver')}
    isEditable
    operator="contains"
    control={control}
    setValue={setValue}
   />
   <h3>{t('dashboard.filters.measurementUnits')}</h3>
   <FormControl fullWidth>
    <InputLabel id="sort-order-label">
     {t('dashboard.filters.sortOrder')}
    </InputLabel>
    <Controller
     name="sortOrder"
     control={control}
     render={({ field }) => (
      <Select
       {...field}
       labelId="sort-order-label"
       id="sort-order"
       label={t('dashboard.filters.sortOrder')}
       value={field.value || 'desc'}
      >
       <MenuItem value="desc">{t('dashboard.filters.descending')}</MenuItem>
       <MenuItem value="asc">{t('dashboard.filters.ascending')}</MenuItem>
      </Select>
     )}
    />
   </FormControl>
  </>
 );
};

export default DriversProgressFilters;
